import { render, staticRenderFns } from "./MessageBox.vue?vue&type=template&id=6b4c2e73&"
import script from "./MessageBox.js?vue&type=script&lang=js&"
export * from "./MessageBox.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b4c2e73')) {
      api.createRecord('6b4c2e73', component.options)
    } else {
      api.reload('6b4c2e73', component.options)
    }
    module.hot.accept("./MessageBox.vue?vue&type=template&id=6b4c2e73&", function () {
      api.rerender('6b4c2e73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/MessageBox/MessageBox.vue"
export default component.exports